import { window } from 'shared/utils/browser'

export const STORAGE_KEY = '_gcx'

export const STORAGE_KEYS = {
  dashboard: 'dashboard-filters',
  email: 'email',
  theme: 'theme',
  navigation: 'nav-expanded',
  programManagementDynamicColumns: 'program-management-dynamic-columns',
  // a remembered preference for the user's last picked project creation method (from template vs quick)
  createProjectMethodPreference: 'create-project-method-preference',
  project: 'project-filters',
  projectFiltersV2: 'project-filters-v2',
  projectListColumnSize: 'project-list-column-size',
  projectListDynamicColumns: 'project-list-dynamic-columns',
  projectsSortBy: 'project-sort-by',
  projectView: 'project-view-v2',
  search: 'search',
  templateListDynamicColumns: 'template-list-dynamic-columns',
  templatesSortBy: 'templates-sort-by',
  token: 'token',
  impersonate: 'impersonate',
  projectPlanView: 'project-plan-view',
  // the Board/List view picked on the template edit pages, shared by all templates
  templateView: 'template-view',
  taskDrawerCustomFieldsRequiredExpanded:
    'task-drawer-custom-fields-required-expanded',
  taskDrawerCustomFieldsOptionalExpanded:
    'task-drawer-custom-fields-optional-expanded',
  lastOptedInVersion: 'last-opted-in-version',
  reportingFilters: 'reporting-filters',
}

export const buildUniqueKey = (key: string): string => `${STORAGE_KEY}.${key}`

export const getItem = (
  key: string,
  storage: Storage | undefined = window?.sessionStorage,
): string | undefined | null => storage?.getItem(buildUniqueKey(key))

export const removeItem = (
  key: string,
  storage: Storage | undefined = window?.sessionStorage,
): void => storage?.removeItem(buildUniqueKey(key))

type RemoveOnReloadCallback = {
  (): void
}

export const removeOnReload = (storageKey: string): RemoveOnReloadCallback => {
  const handleRemoveOnReload = () => {
    removeItem(storageKey)
  }

  window?.addEventListener('beforeunload', handleRemoveOnReload)
  return () => {
    window?.removeEventListener('beforeunload', handleRemoveOnReload)
  }
}

export const setItem = (
  key: string,
  value: string,
  storage: Storage | undefined = window?.sessionStorage,
): void => storage?.setItem(buildUniqueKey(key), value)
